<template>
    <component :is="dynamicComponent" :style="style" />
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        width: {
            type: [String, Number],
            default: '24',
        },
        height: {
            type: [String, Number],
            default: '24',
        },
    },

    computed: {
        dynamicComponent() {
            const icon = this.icon.charAt(0).toUpperCase() + this.icon.slice(1);
            return () => import(`vcomponents/icons/Icon${icon}.vue`);
        },
        style() {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`,
            };
        },
    },
};
</script>
